export default {
    vendorCode: 'Vendor name',
    payPeriodId:
        'The pay period which this SPIFF should be applied to (Pay period must be unlocked!)',
    beneficiaryUserId:
        'The bargreen email for the beneficiary user of this SPIFF',
    description: 'A brief description of why this spiff is being paid',
    amount: 'The amount to be paid for this SPIFF'
};
